import { render, staticRenderFns } from "./product-testing-form.vue?vue&type=template&id=bcfeb5ea"
import script from "./product-testing-form.vue?vue&type=script&lang=js"
export * from "./product-testing-form.vue?vue&type=script&lang=js"
import style0 from "./product-testing-form.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports